export enum ApiFailCode {
    GROUP_ROLE_REQ_FOR_ROUTE = 'GROUP_ROLE_REQ_FOR_ROUTE',
    NO_SHOW_LOCK = 'NO_SHOW_LOCK',
}